import { useState } from "react";

import { useConfig } from "../../context/config-context";

import FluxBolusTab from "../Intervention/FluxBolus/tab";
import MetricTab from "../Intervention/Metric/tab";
import InterventionTab from "../Intervention/tab";
import TabContainer from "../TabContainer";
import TimelineTab from "../Timeline/tab";

const PatientTab = ({ className, patient, metrics }) => {
  const [activeTab, setActiveTab] = useState(1);
  const siteConfig = useConfig();

  return (
    <TabContainer
      data={siteConfig.components.patient_tabs.map((tab, index) => ({
        value: index + 1,
        label: tab.label,
      }))}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      className={className}
    >
      <div className="p-5 pt-0">
        {activeTab === 1 &&
          (patient.contracts &&
          patient.contracts.length > 0 &&
          patient.interventions &&
          patient.interventions.length > 0 ? (
            <TimelineTab
              firstContract={patient.firstContract}
              contracts={patient.contracts}
              interventions={patient.interventions || []}
            />
          ) : (
            <div className="w-full my-5 text-center text-neutral-dark">
              {
                siteConfig.components.patient_tabs.find(
                  (t) => t.id === "timeline"
                ).none
              }
            </div>
          ))}
        {activeTab === 2 && (
          <InterventionTab interventions={patient.interventions} />
        )}
        {activeTab === 3 && <MetricTab metrics={metrics} patient={patient} />}
        {activeTab === 4 && <FluxBolusTab metrics={metrics} patient={patient} />}
      </div>
    </TabContainer>
  );
};

export default PatientTab;
